module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAOKADAAQAAAABAAAAOAAAAAANV2hTAAAA+ElEQVRoBe3YMQrCMBTG8UYcdHPXKzl6DvEAegdHvUJHb6HX0N2tbvELdLBbXx4JKv9AkML78tofQkKahoEAAggggAACCCCAAAIIIICAQSDGeNDsNEuP1GNveLVBaRg8GR7U9K7ypSHiKX2EEFY5C0xzQn1mp9+t5syxxpjoS0XHMYXUIIAAAgggYBTwbPQL9Vprzo09reWdAhdt9E9r0FWvk8yt9BntY/1r7stOcoPKRUe2WpS/aDVqGiGAAAIIfKGAZx/c6HuqXVnoqNbm+Hk+8CcunTxHtbNE04VQ6ZF6nEo3YX0EEEAAAQQQQAABBBBAAIH/EngDGy0AVFq2oOsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/menu.png
// module id = 8wfO
// module chunks = 1